module.exports = __webpack_public_path__ + "img/selected4-min.49054b74.png";